import React from 'react';
import type { CartWidgetData } from '../../types/widgets';
import { useBagWords } from '../../../../utils/hooks/useBagWords';

export interface CartWidgetProps {
  data: CartWidgetData;
}

export const CartWidget: React.FC<CartWidgetProps> = ({ data }) => {
  const { item, qty, total, isSubscription } = data;
  const { bag } = useBagWords();

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 400,
        background: 'var(--voice-widget-card-bg, #FFFFFF)',
        border: '1px solid var(--voice-widget-border, #E5E7EB)',
        borderRadius: 16,
        padding: '20px 20px 16px',
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
      }}
    >
      {/* Added-to-bag header */}
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: 'uppercase',
          color: 'var(--voice-widget-accent, #7DD3C0)',
          marginBottom: 12,
        }}
      >
        Added to {bag}
      </div>

      {/* Product row */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
        {item.imageUrl && (
          <img
            src={item.imageUrl}
            alt={item.title}
            style={{
              width: 64,
              height: 64,
              objectFit: 'contain',
              borderRadius: 8,
              background: 'var(--voice-widget-img-bg, #F9FAFB)',
              flexShrink: 0,
            }}
          />
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: 'var(--voice-widget-fg, #111827)',
              lineHeight: 1.35,
              marginBottom: 4,
            }}
          >
            {item.title}
          </div>
          <div style={{ fontSize: 13, color: 'var(--voice-widget-muted, #6B7280)' }}>
            Qty: {qty}
            {isSubscription && ' · Subscribe & Save'}
          </div>
        </div>
      </div>

      {/* Divider + total */}
      <div
        style={{
          borderTop: '1px solid var(--voice-widget-border, #E5E7EB)',
          margin: '14px 0 12px',
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 14,
        }}
      >
        <span style={{ fontSize: 13, color: 'var(--voice-widget-muted, #6B7280)' }}>Total</span>
        <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--voice-widget-fg, #111827)' }}>{total}</span>
      </div>

      {/* Action buttons — visual only in Plan 2a; per-tool wiring in 2b/2c */}
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          style={{
            flex: 1,
            padding: '10px 12px',
            borderRadius: 999,
            border: 'none',
            background: 'var(--voice-widget-accent, #7DD3C0)',
            color: 'var(--voice-widget-accent-fg, #FFFFFF)',
            fontSize: 13,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Checkout
        </button>
        <button
          type="button"
          style={{
            flex: 1,
            padding: '10px 12px',
            borderRadius: 999,
            border: '1.5px solid var(--voice-widget-border, #E5E7EB)',
            background: 'transparent',
            color: 'var(--voice-widget-fg, #111827)',
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Keep talking
        </button>
      </div>
    </div>
  );
};

export default CartWidget;
